import { TabsProps } from '@shape-ds/components';
import { ASSET_CATEGORIES } from 'config/constants';
import { ASSET_PAGE } from 'config/paths';
import { useFeatureFlag } from '@shape/feature-flag';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const disabledTabs = ['models'];

const assetSubRoutes = ['overview', 'health', 'monitoring'];

const useGetTabs = (categories?: string[]) => {
  const isOilSystemEnabled = useFeatureFlag('oil-system');
  const isFlareSystemEnabled = useFeatureFlag('flare-modec');

  return useMemo(() => {
    const defaultTabs = ['overview', 'events', 'cases', 'health'];

    if (isOilSystemEnabled) {
      defaultTabs.push('oil_system');
    }

    if (isFlareSystemEnabled) {
      defaultTabs.push('flare');
    }

    return categories?.includes(ASSET_CATEGORIES.MODEL_VIEW)
      ? [...defaultTabs, 'models']
      : defaultTabs;
  }, [categories, isOilSystemEnabled, isFlareSystemEnabled]);
};

export const useTabsDefault = (assetId?: string | number, categories?: string[]): TabsProps => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const tabs = useGetTabs(categories);
  const data = tabs.map((tab) => ({
    value: tab,
    label: t(`components:header.tab_menu.${tab}`),
    disabled: disabledTabs.includes(tab),
  }));

  return {
    data,
    onChange: (event, value) => {
      if (assetSubRoutes.includes(value)) {
        return navigate(ASSET_PAGE(undefined, value));
      }
      return navigate(`/${value}`);
    },
    value: useMemo(
      () =>
        tabs.find((tab) => {
          if (location.pathname.includes('event') && tab === 'events') {
            return true;
          }
          return location.pathname.includes(tab);
        }) ?? 'overview',
      [location.pathname, tabs],
    ),
  };
};
